export default __webpack_public_path__ + "static/media/gallery-wip-assembly_00.d6fed6ab.jpg";